import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {CacheObjectService, DeviceService} from '@app/core';
import {IndicatorService} from '@app/shared';
import {FeedbackItemModel, FeedbackResponseModel} from "@app/app/feedback/feedback.model";
import {filter, map, tap} from "rxjs/operators";
import {GoftinoService} from "@app/core/goftino.service";
import {
  DialogPhoneNumberSupportScoreComponent
} from "@app/app/feedback/dialog-phone-number-support/dialog-phone-number-support.component";
import {DialogService} from "@app/components/dialog/dialog.service";
import {NavigationEnd, NavigationStart, Router} from "@angular/router";
import {Subscription} from "rxjs";
import {BackKeyUrlService} from "@app/components/header/back-key-url.service";

@Component({
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss', '../profile/profile-edit/profile-edit.component.scss'],
})
export class FeedbackComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('unread_count_message_goftino', {
    static: false,
    read: ElementRef
  }) private countGoftinoEl: ElementRef<HTMLSpanElement>;
  public questionItems: Array<FeedbackItemModel> = [];
  public selectedItemQuestion: number | null = null;
  public isPhoneDevice: boolean;
  private subscription: Subscription = new Subscription();

  constructor(
    private readonly backKeyUrlService: BackKeyUrlService,
    private readonly router: Router,
    private readonly route: Router,
    public readonly deviceService: DeviceService,
    private readonly goftinoService: GoftinoService,
    private readonly indicator: IndicatorService,
    private readonly cache: CacheObjectService<any>,
    private readonly dialog: DialogService) {
  }

  ngAfterViewInit(): void {
    const unread = this.goftinoService.getUnreadCount();
    if (unread && unread > 0) {
      this.countGoftinoEl.nativeElement.style.display = 'flex';
    } else {
      this.countGoftinoEl.nativeElement.style.display = 'none';
    }
    this.countGoftinoEl.nativeElement.innerText = unread.toString();
  }

  public ngOnInit() {
    this.isPhoneDevice = (this.deviceService.isAndroid() || this.deviceService.isIOS());
    this.subscription.add(this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart || event instanceof NavigationEnd))
      .subscribe((event: NavigationStart | NavigationEnd) => {
        if (event instanceof NavigationStart && event.restoredState) {
          console.log('FEEDBACK-POPSTATE')
          // if (this.deviceService.isAndroid() || this.deviceService.isIOS())
          //   this.backKeyUrlService.goBack(['./profile']);
          // else
          //   this.route.navigate(['./profile']);
        }
      }));
    this.cache.getObjectCache('/api/faqs/support')
      .pipe(map((z: FeedbackResponseModel) => z.items)).subscribe(c => {
      this.questionItems = c;
      this.indicator.hide();
    })
  }

  public callToPhone(phone: string) {
    if (this.deviceService.isAndroid()) {
      (window as any).Android.callToPhone(phone);
    } else if (this.deviceService.isIOS()) {

    }
  }

  public openShowPhoneNumberSupportDialog(event: Event, phoneNumber: string): void {
    event.stopPropagation();
    event.preventDefault();
    let dialogRef = this.dialog.open(DialogPhoneNumberSupportScoreComponent, {
      data: {phoneNumber}
    });

    dialogRef.afterClosed.subscribe(res => {
      return;
    })
  }

  public routeToGoftino() {
    this.indicator.show();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
